import { twMerge } from "tailwind-merge";
import { Panel } from "../panel/panel";
import { ReactNode } from "react";

export const DetailList = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <Panel
    className={twMerge("laptop:p-0 flex flex-wrap p-0", className)}
    component={"dl"}
  >
    {children}
  </Panel>
);

export const DetailTerm = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <dt
    className={twMerge(
      "w-1/2 whitespace-nowrap border-b-[1px] border-neutral-500 px-3 py-2 text-sm font-semibold last-of-type:border-none sm:w-1/3",
      className,
    )}
  >
    {children}
  </dt>
);

export const DetailDescription = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <dd
    className={twMerge(
      "flex w-1/2 flex-col items-end justify-end whitespace-nowrap border-b-[1px] border-neutral-500 px-3 py-2 text-right text-sm last-of-type:border-none sm:w-2/3",
      className,
    )}
  >
    {children}
  </dd>
);
